export default __webpack_public_path__ + "static/media/Leads2@32.a81d8064.svg";